import { Component } from '@angular/core';

@Component({
  selector: 'app-equal-opportunities',
  templateUrl: './equal-opportunities.component.html',
  styleUrl: './equal-opportunities.component.scss'
})
export class EqualOpportunitiesComponent {

}
